module.exports = __webpack_public_path__ + "static/media/delete.023b3fdb.svg";